import { Dialog } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ImLocation } from 'react-icons/im';
import { BsFillTelephoneFill } from 'react-icons/bs';
import RequestAppointmentForm from './RequestAppointmentForm';
import logo from '../../../assests/requestAppointment.svg';

import RequestAppointmentSvg from './RequestAppointmentSvg';

const getInitials = (name) => (name || '')
  .trim()
  .split(/\s+/)
  .slice(0, 2)
  .map((word) => word[0])
  .join('')
  .toUpperCase();

const logoClass = 'h-20 w-20 shrink-0 rounded-2xl bg-white shadow-md ring-1 ring-black/5';

const RequestAppointment = ({ data, setPopup }) => {
  // Fall back to company initials when the logo is missing or fails to load
  const [logoFailed, setLogoFailed] = useState(false);

  useEffect(() => {
    setLogoFailed(false);
  }, [data?.logo]);

  const hasLogo = data && data.logo !== null && data.logo !== '';

  return (
   
    <div className="flex w-full flex-col overflow-hidden rounded-2xl sm:flex-row">
      <div className="hidden w-full space-y-5 border-r border-slate-100 bg-slate-50 p-8 sm:block sm:w-1/3">
        <div className="flex flex-col items-center justify-center text-center">
          {hasLogo && !logoFailed && (
            <img
              className={`${logoClass} mb-4 object-cover`}
              src={data.logo}
              alt="logo"
              onError={() => setLogoFailed(true)}
            />
          )}
          {(!hasLogo || logoFailed) && data?.company?.name && (
            <div className={`${logoClass} mb-4 flex items-center justify-center text-xl font-medium text-slate-600`}>
              {getInitials(data?.company?.name)}
            </div>
          )}
          <div className="text-lg font-semibold tracking-tight text-slate-900">
            {data?.company?.name}
          </div>
        </div>
            
        <div className="flex items-start space-x-3 text-[13px] leading-relaxed text-slate-600">
          <span className="mt-0.5 shrink-0 text-slate-400"> 
            {' '}
            <ImLocation sx={{ fontSize: '13px' }} />
            {' '}
          </span>
          <span>
            {' '}
            {data?.address?.street_address} 
            {' '}
            {data?.address?.apartment_or_suite}
            {data?.address?.city} 
            {' '}
            {data?.address?.state_or_province} 
            {' '}
            {data?.address?.country}
          </span>
        </div>

        <div className="flex items-center space-x-3 text-[13px] text-slate-600">
          <span className="shrink-0 text-slate-400"> 
            {' '}
            <BsFillTelephoneFill />
            {' '}
          </span>
          <span>
            {' '}
            {data?.company?.phone_number !== null ? data?.company?.phone_number : 'Not Available'}
          </span>
        </div>
      
        <div>
          <RequestAppointmentSvg />
        </div>
      </div>
      <div className="w-full sm:w-2/3">
        <RequestAppointmentForm data={data} setPopup={setPopup} />
      </div>
    </div>
  
  );
};

export default RequestAppointment;
